import { Card, CardBody, Col, FormFeedback, Row, FormGroup } from "reactstrap";
import { LabelText } from "../Utils/Input";
import SelectField from "../Utils/SelectField";
import InputField from "../Utils/InputField";
import { Formik } from "formik";
import { CancelOrderOptions } from "./constants/initialValues";
import { handleChangeForReason } from "./constants/HandleReasonChange";

export const CancelOrder = ({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  setFieldTouched,
  setFieldValue,
  setReason,
}) => {
  return (
    <Col>
      <div>
        <div>
          <h5 className="fs-16 fw-semi-bold text-black mb-3">Reason For cancellation</h5>
          <h6 className="fs-14 fw-semibold mb-3">Reason</h6>
                    <Row>

            <Col md={3} xs={6}>
              <FormGroup>
                <LabelText
                  htmlFor={"selectReason"}
                  classLabelName={`d-block ms-0 rv-sub-label ${(errors.reason && touched.reason) || false ? "rv-label-danger" : "rv-label-muted"}`}
                  displayText={
                    touched.reason &&
                      errors.reason
                      ? errors.reason
                      : `Select Reason`
                  }
                />
                <SelectField
                  name="selectReason"
                  value={values.reason}
                  className={"z-3"}
                  options={[...CancelOrderOptions]}
                  handleChange={handleChangeForReason(setFieldTouched, setFieldValue, "reason", setReason)}
                  placeholder={""}
                  isRVStyle={true}
                />
              </FormGroup>
            </Col>
            <Col md={9} xs={6}>
            <LabelText
                  htmlFor={"comment"}
                  classLabelName={`d-block ms-0 rv-sub-label ${values.reason.value === "Other" && touched.comment && errors.comment ? "rv-label-danger" : "rv-label-muted"}`}
                  displayText={
                    values.reason.value === "Other" && touched.comment && errors.comment ? errors.comment
                      : `Enter Reason`
                  }
                />
            <InputField
                name={"comment"}
                type={"text"}
                className={"form-control bg-transp"}
                disabled={values.reason.value !== "Other"}
                value={values.comment}
                handleChange={handleChange}
                handleBlur={handleBlur}
                placeholder={""}
                invalid={
                  values.reason.value === "Other" && touched.comment && errors.comment ? true : false
                }
              />
            </Col>
          </Row>
        </div>
      </div>
    </Col>
  );
};
